import questionTypes from '../questionTypes';
import formatValidationTypeList from '../formatValidationTypeList';
import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentMail,
  getDefaultProps: () => ({
    ...getCommonBlockProps({ required: true }),
    label: 'Email',
    formatValidationType: formatValidationTypeList.email,
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isUniqueField: () => true,
    isRequiredField: () => false,
    isTextRequired: () => false,
  },
};
